export default __webpack_public_path__ + "static/media/status-unknown.2fe767b4.svg";